export default function SubtleGridBackground({
  size = 40,
  opacityClass = 'opacity-[0.02] dark:opacity-[0.03]',
  className = '',
}) {
  return (
    <div
      className={`absolute inset-0 pointer-events-none ${opacityClass} text-gray-900 dark:text-white ${className}`}
      style={{
        backgroundImage: `
          linear-gradient(to right, currentColor 1px, transparent 1px),
          linear-gradient(to bottom, currentColor 1px, transparent 1px)
        `,
        backgroundSize: `${size}px ${size}px`,
        color: 'currentColor',
        zIndex: 0,
      }}
      aria-hidden="true"
    />
  );
}


